// global
import React, { memo } from 'react';
import PropTypes from 'prop-types';
// api
import * as CrudProfession from 'app/api/crudProfession';
// components
import DefaultDropdown from 'app/components/commons/dropdownForm/common/DefaultDropdown';
// hooks
import useDefaultDropdown from 'app/components/commons/dropdownForm/hooks/useDefaultDropdown';

function ProfessionDropdown(props) {
  const {
    condition,
    dependency,
    disabled,
    error,
    inline,
    label,
    onChange,
    placeholder,
    required,
    size,
    searchable,
    value,
    width,
    helperText
  } = props;

  const fetchData = () => CrudProfession.listDropdownProfessions();

  const { options, loading } = useDefaultDropdown({ fetchData });

  return (
    <DefaultDropdown
      condition={condition}
      dependency={dependency}
      disabled={disabled}
      error={error}
      inline={inline}
      label={label}
      loading={loading}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      required={required}
      searchable={searchable}
      value={value}
      width={width}
      size={size}
      helperText={helperText}
      multiple={false}
    />
  );
}

ProfessionDropdown.defaultProps = {
  searchable: false,
  label: 'Tipo de profissão',
  placeholder: 'Selecionar tipo de profissão'
};

ProfessionDropdown.propTypes = {
  condition: PropTypes.bool,
  dependency: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.shape({
    error: PropTypes.string,
    groupIndexes: PropTypes.array,
    repeated: PropTypes.bool
  }),
  inline: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  value: PropTypes.any,
  width: PropTypes.number
};

export default memo(ProfessionDropdown);
